import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { AnswerType } from "vmd-types";

// getLocalizedMessage returns the key itself on a miss, so `... || "Fallback"`
// never triggers; this helper falls back explicitly when the key is missing.
export const t = (language: string, key: string, fallback: string): string => {
  const message = getLocalizedMessage(language, key);
  return !message || message === key ? fallback : message;
};

export const getAnswerTypeOptions = (
  language: string
): { value: AnswerType; label: string }[] => [
  { value: "text", label: t(language, "formBlocks.answerType.text", "Text") },
  {
    value: "number",
    label: t(language, "formBlocks.answerType.number", "Number"),
  },
  {
    value: "percentage",
    label: t(language, "formBlocks.answerType.percentage", "Percentage"),
  },
  { value: "date", label: t(language, "formBlocks.answerType.date", "Date") },
  {
    value: "singleSelect",
    label: t(language, "formBlocks.answerType.singleSelect", "Single Select"),
  },
  {
    value: "multiSelect",
    label: t(language, "formBlocks.answerType.multiSelect", "Multi Select"),
  },
  {
    value: "textList",
    label: t(language, "formBlocks.answerType.textList", "Text List"),
  },
  {
    value: "environmentUrlList",
    label: t(
      language,
      "formBlocks.answerType.environmentUrlList",
      "Environment URL List"
    ),
  },
];

export const isSelectAnswerType = (type: AnswerType): boolean =>
  type === "singleSelect" || type === "multiSelect";

export const boundFieldNote = (language: string, ref: string): string =>
  `${t(language, "formBlocks.boundField", "Bound to master data")}: ${ref}`;
